import qs from 'qs';

import type { WORKFLOW_TYPE } from '@/types/workflowConst';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { v1ApiClient } from '..';

const workflowService = {
  async fetchWorkflowList(types: WORKFLOW_TYPE[]): Promise<Workflow[]> {
    const wa = getCurrWorkspaceAlias();
    const res = await v1ApiClient.get(`/workspaces/${wa}/notifications`, {
      params: {
        types,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    });
    return res.data;
  },
  async fetchWorkflow(alias: string): Promise<Workflow> {
    const res = await v1ApiClient.get(`/notifications/${alias}`);
    return res.data;
  },
  async previewWorkflow(params: CreateWorkflowParams) {
    const wa = getCurrWorkspaceAlias();
    const res = await v1ApiClient.post(
      `/workspaces/${wa}/notifications/preview`,
      params,
    );
    return res.data;
  },
  async createWorkflow(params: CreateWorkflowParams): Promise<Workflow> {
    const wa = getCurrWorkspaceAlias();
    const res = await v1ApiClient.post(
      `/workspaces/${wa}/notifications`,
      params,
    );
    return res.data;
  },
  async updateWorkflow(params: UpdateWorkflowParams) {
    const res = await v1ApiClient.put(`/notifications/${params.alias}`, params);
    return res.data;
  },
  async toggleWorkflow(alias: string, enable: boolean) {
    const res = await v1ApiClient.patch(`/notifications/${alias}/enable`, {
      enable,
    });
    return res.data;
  },
  async deleteWorkflow(alias: string) {
    const res = await v1ApiClient.delete(`/notifications/${alias}`);
    return res.data;
  },
};

export default workflowService;
